<script lang="ts">
    import { _ } from 'svelte-i18n';
    import ErrorColor from './ErrorColor.svelte';
    import { FriendlyDateGenerator } from '../utilities/FriendlyDateGenerator';
    import IconFlashOn from './Icons/IconFlashOn.svelte';
    import SwitchAdHoc from '../components/Jobs/SwitchAdHoc.svelte';
    import { debug } from '../../stores/store';

    export let simpleView = false;
    export let friendlyTargetDate: FriendlyDateGenerator;
    export let isAdHoc: boolean = false;
    export let jobId: number | null = null;
    export let disabled: boolean = false;
</script>

<div style="display: flex; column-gap: 6px;">
    {#if jobId !== null || $debug}
        <!--{disabled}-->
        <SwitchAdHoc {jobId} adHoc={isAdHoc} {disabled} />
    {/if}

    <div>
        {#if simpleView}
            {#if friendlyTargetDate.getRelativeTodayText(true) !== ''}
                <div
                    class={friendlyTargetDate.isToday() ? 'bold' : 'light'}
                    style="text-transform: capitalize;"
                >
                    {$_(friendlyTargetDate.getRelativeTodayText(true))}
                </div>
            {:else}
                <ErrorColor>
                    <div class="light">{$_('undefined')}</div>
                </ErrorColor>
            {/if}
        {:else if friendlyTargetDate.getRelativeTodayText(true) !== ''}
            <div
                class={friendlyTargetDate.isToday() ? 'bold' : 'light'}
                style="text-transform: capitalize;"
            >
                {$_(friendlyTargetDate.getRelativeTodayText(true))}
            </div>
            <div class="light">
                {friendlyTargetDate.getRelativeTodayText(true) !==
                friendlyTargetDate.getDayAndMonthNumeric()
                    ? $_(friendlyTargetDate.getDayAndMonthNumeric())
                    : ''}
            </div>
        {:else}
            <ErrorColor>
                <div class="light">{$_('undefined')}</div>
            </ErrorColor>
        {/if}
    </div>
</div>

<!--
{#if simpleView}
    {#if job.target_date!==null}
        <div class="{friendlyTargetDate.isToday()? 'bold': 'light'}">{$_(friendlyTargetDate.getRelativeTodayText(true))}</div>
    {:else}
        <ErrorColor>
            <div class="light">{$_('undefined')}</div>
        </ErrorColor>
    {/if}
{:else}
    {#if job.target_date!==null}
        <div class="{friendlyTargetDate.isToday()? 'bold': 'light'}">{$_(friendlyTargetDate.getRelativeTodayText(true))}</div>
        <div class="light">{friendlyTargetDate.getRelativeTodayText(true)!==friendlyTargetDate.getDayAndMonthNumeric() ? friendlyTargetDate.getDayAndMonthNumeric() : ''}</div>
    {:else}
        <ErrorColor>
            <div class="light">{$_('undefined')}</div>
        </ErrorColor>
    {/if}
{/if}
-->
